/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import chunk from '@linc-technologies/linced-common/utils/chunk';
import { hash } from '@linc-technologies/linced-common/utils/promise';

// The people query sends the ids in the URL. 50 ids keep the URL under the
// proxy limit of about 8KB.
const LEARNER_CHUNK = 50;

export default class SearchRoute extends Route {
  queryParams = {
    query: {
      refreshModel: true,
    },
  };

  // Services
  @service
  schoolSchema;

  @service
  session;

  @service
  store;

  @service
  students;

  async model(params) {
    const model = await hash({
      people: this.store.query('person', {
        query: params.query,
        includeFormer: true,
      }),
      staffUsers: this.store.query('user', {
        allowedTenantAccess: this.session.activeSchool,
        scopesUnion:
          'urn:linced:organisation:role:staff,urn:linced:organisation:role:admin',
      }),
      jurisdictionalIdField: this.schoolSchema.getJurisdictionalIdField(),
    });

    // Load the learners of all caregivers in batches, so that the results can
    // show them. Do not load the learners that are in the store.
    const learnerIds = new Set();
    for (const person of model.people) {
      if (!person.caregiver) {
        continue;
      }
      for (const id of person.caregiver.learnerIds) {
        if (!this.store.peekRecord('person', id)) {
          learnerIds.add(id);
        }
      }
    }
    await Promise.all(
      chunk([...learnerIds], LEARNER_CHUNK).map((ids) =>
        this.store.query('person', {
          people: JSON.stringify(ids),
          includeFormer: true,
        }),
      ),
    );
    return model;
  }

  afterModel() {
    // Trigger load of all students, if not already loaded.
    // This avoids near-empty groups if navigating to a student from the results, then to their homeroom.
    this.get('students.all');
  }

  deactivate() {
    this.controller.reset();
  }
}
